/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import SectionBlock from '@/components/license-history/license-history-summary-modal/SectionBlock'
import SectionTitle from '@/components/license-history/license-history-summary-modal/SectionTitle'
import { HStack, Image, Text, VStack } from '@chakra-ui/react'
import React from 'react'

const AllowedIASection = ({ aiTags = [] }) => {
  if (aiTags?.length < 0) return null

  return (
    <SectionBlock>
      <SectionTitle>Allowed AI Systems</SectionTitle>
      <VStack spacing={2} align="stretch">
        { aiTags.map((tag) => (
          <HStack
            key={tag.id}
            spacing={3}
            p={3}
            borderWidth="1px"
            borderRadius="md"
            borderColor="gray.200"
          >
            { tag.llmCompany.logoUrl && (
              <Image
                src={tag.llmCompany.logoUrl}
                alt={tag.llmCompany.name}
                boxSize="24px"
                borderRadius="sm"
              />
            )}
            <VStack spacing={0} align="stretch" flex={1}>
              <Text className="font-medium text-sm">
                {tag.name} ({tag.llmCompany.name})
              </Text>
              <Text className="text-xs text-gray-600">
                Category: {tag.category}
              </Text>
            </VStack>
          </HStack>
        ))}
      </VStack>
    </SectionBlock>
  )
}

export default AllowedIASection
